import { useEffect, useState, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { obtenerMuestroCarrito } from '../services/motorService';
import RoomTypeRatePlanContext from '../components/contexts/RoomTypeRatePlanContext';
import RoomsContext from '../components/contexts/RoomsContext';

import Cookies from 'js-cookie';


const SESSION_EXPIRY_TIME = 30 * 60 * 1000; // 30 minutos


const getSession = () => {
    const sessionData = localStorage.getItem('sessionData');
    return sessionData ? JSON.parse(sessionData) : null;
};

const setSession = (session) => {
    const sessionData = {
        session,
        timestamp: Date.now(),
    };
    localStorage.setItem('sessionData', JSON.stringify(sessionData));
};

const generateSession = (fetchCartCallback, setRooms) => {
    const newSession = uuidv4().replace(/-/g, '');;
    console.log('New session:--------------', newSession);
    setSession(newSession);
    setRooms((prevRooms) => prevRooms.map(room => ({ ...room, isInCart: false })));
    const hotcod = Cookies.get('hotCod');
    fetchCartCallback(newSession, hotcod);
    return newSession;
};

const useCart = () => {
    const { setCartItems } = useContext(RoomTypeRatePlanContext);

    const fetchCart = async (session, hotcod) => {
        try {
            const cart = await obtenerMuestroCarrito(hotcod, session);
            console.log('CARRITO EN PANTALLA SESION:', cart);
            if (cart && cart.length > 0) {
                setCartItems(cart);
            } else {
                setCartItems({
                    cartNoPrice: [],
                    price: 0
                });
                console.log('No cart data found');
            }
        } catch (error) {
            console.error('Error fetching cart data:', error);
        }
    };

    return fetchCart;
};

const useSession = () => {
    const fetchCart = useCart();
    const hotcod = Cookies.get('hotCod');
    const { setRooms } = useContext(RoomsContext);
    const [session, setSessionState] = useState(() => {
        const storedSession = getSession();
        if (storedSession) {
            const isExpired = Date.now() - storedSession.timestamp > SESSION_EXPIRY_TIME;
            if (isExpired) {
                return generateSession(fetchCart,setRooms);
            } else {
                fetchCart(storedSession.session, hotcod); // Fetch cart data on initial load
            }
            return storedSession.session;
        } else {
            return generateSession(fetchCart,setRooms);
        }
    });

    useEffect(() => {
        const refreshSession = () => {
            const storedSession = getSession();
            if (storedSession) {
                const isExpired = Date.now() - storedSession.timestamp > SESSION_EXPIRY_TIME;
                if (isExpired) {
                    const newSession = generateSession(fetchCart,setRooms);
                    setSessionState(newSession);
                } else {
                    setSessionState(storedSession.session);
                    setSession(storedSession.session);
                }
            } else {
                const newSession = generateSession(fetchCart,setRooms);
                setSessionState(newSession);
            }
        };

        const interval = setInterval(refreshSession, 60 * 1000);

        window.addEventListener('click', refreshSession);
        window.addEventListener('mousemove', refreshSession);
        window.addEventListener('keypress', refreshSession);

        return () => {
            clearInterval(interval);
            window.removeEventListener('click', refreshSession);
            window.removeEventListener('mousemove', refreshSession);
            window.removeEventListener('keypress', refreshSession);
        };
    }, [fetchCart, setRooms]);


    return session;
};

export default useSession;